import { Box, Dialog, DialogContent } from "@mui/material";
import Button from "../../../../../../components/ui/Button";
import Text from "../../../../../../components/ui/Text";

export const DeletePaymentDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Text variant="subtitle1" sx={{ mb: 2 }}>
          Delete Payment Method
        </Text>
        <Text variant="paragraph" color="#666">
          Are you sure you want to delete this payment method?
        </Text>
      </DialogContent>

      <Box sx={{ p: 2, gap: 1, display: "flex", flexDirection: "column" }}>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={isDeleting}
          sx={{
            flex: 1,
            bgcolor: "#FF4D4F",
            borderColor: "#FF4D4F",
            "&:hover": { bgcolor: "#FF7875", borderColor: "#FF7875" },
          }}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isDeleting}
          sx={{ flex: 1 }}
        >
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
};
